import httpService from '@/services/httpService'

export const types = {
  ADD_LINKS_DATA: 'links/ADD_LINKS_DATA'
}

const state = {
  links: []
}

const mutations = {
  [types.ADD_LINKS_DATA]: function (state, links) {
    state.links = links
  }
}

const actions = {
  getLinkData: async function ({ commit , dispatch}, { clientId, filters }) {
    const params = { filters: JSON.stringify(filters) }
    const response = await httpService.get(`/link/${clientId}`, { params })
    if (!response) {
      commit(types.ADD_LINKS_DATA, [])
      return []
    }
    commit(types.ADD_LINKS_DATA, response.data)
    return response.data
  },
  updateLinks: function ({ commit }, { clientId, data }) {
    return httpService.post(`/links/bulk-update/${clientId}`, { form: JSON.stringify(data) },
      { successMessage: 'Links successfully updated', raiseError: true, cancelErrorMessage: true })
  },
  createLinks: function ({ commit }, { clientId, data }) {
    return httpService.post(`/links/${clientId}`, { form: JSON.stringify(data) },
      { successMessage: 'Links successfully created', raiseError: true, cancelErrorMessage: true })
  },
  createLink: function ({ commit }, { clientId, link }) {
    return httpService.post(`/link/${clientId}`, link,
      { successMessage: 'Link successfully created', raiseError: true, cancelErrorMessage: true })
  },
  deleteLinkById: function ({ commit }, { clientId, id }) {
    const config = {
      params: {
        id
      },
      successMessage: 'Link successfully deleted',
      raiseError: true,
      cancelErrorMessage: true
    }
    return httpService.delete(`/link/${clientId}`, config)
  },
  updateLink: function ({ commit }, { clientId, link }) {
    return httpService.patch(`/link/${clientId}`, link,
      { successMessage: 'Link successfully updated', raiseError: true, cancelErrorMessage: true })
  },
  getLinkOptions: async function ({ commit , dispatch}, { clientId }) {
    const response = await httpService.get(`/link/options/${clientId}`)
    return response.data
  },
  uploadAttachment: async function ({ commit, dispatch }, params) {
    return httpService.post('/link/file-upload', params,
      {
        isFormData: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        successMessage: 'Upload successful',
        raiseError: true,
        cancelErrorMessage: true
      })
  },
  getLinkAttachments: async function ({ commit, dispatch }, params) {
    params = {
      id: params
    }
    const response = await httpService.get('/link/attachments', { params })
    return response.data
  },
  deleteAttachmentById: function ({ commit }, id) {
    const config = {
      params: {
        id
      },
      successMessage: 'Attachment deleted',
      raiseError: true,
      cancelErrorMessage: true
    }
    return httpService.delete('/link/delete-attachment', config)
  },
  downloadAttachmentById: async function ({ commit, dispatch }, params) {
    params = {
      id: params
    }
    await httpService.get('/link/download-attachment', { params, responseType: 'arraybuffer' })
      .then((response) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = downloadUrl
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'unknown'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
      })
    return true
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
